import { FC, Fragment, useMemo } from "react";

import Box from "@mui/material/Box";
import { alpha, SxProps, Theme } from "@mui/material/styles";

import { splitForHighlight } from "./helpers";

import { mergeSx } from "@/common/helpers/mergeSx";

export interface DashboardHighlightedTextProps {
  text: string;
  query: string;
  sx?: SxProps<Theme>;
}

const highlightSx: SxProps<Theme> = (theme) => ({
  backgroundColor: alpha(theme.palette.surface.brand.intense, 0.4),
  borderRadius: theme.radius(0.5),
  paddingX: "2px",
});

export const DashboardHighlightedText: FC<DashboardHighlightedTextProps> = ({ text, query, sx }) => {
  const segments = useMemo(() => splitForHighlight(text, query), [text, query]);

  if (segments.length === 1 && !segments[0].isMatch) {
    return <>{text}</>;
  }

  return (
    <>
      {segments.map((segment, index) => (
        <Fragment key={index}>
          {segment.isMatch ? (
            <Box component="span" sx={mergeSx(highlightSx, sx)}>
              {segment.text}
            </Box>
          ) : (
            segment.text
          )}
        </Fragment>
      ))}
    </>
  );
};
